import { ADD_USER_SUCCESS, DELETE_USER_SUCCESS, EDIT_USER_SUCCESS, SET_SYSTEMS_LIST, SET_USER_ROLES, SET_USERS_DATA } from "../actionTypes/users";

const initialState = {
  users: [],
  roles: [],
  systemsList: {}
};

const usersData = (state = initialState, action) => {
  switch (action.type) {
    case SET_USERS_DATA:
      return { ...state, users: action.payload.users };
    case ADD_USER_SUCCESS:
      const newUser = action.payload.user;
      const users = [...state.users, newUser];
      return { ...state, users };
    case DELETE_USER_SUCCESS:
      const userId = action.payload.deletedUserId;
      const updatedUsers = state.users.filter(user => user.UserId !== userId);
      return { ...state, users: updatedUsers };
    case EDIT_USER_SUCCESS:
      const tempUsers = [...state.users];
      const updatedData = action.payload.user;
      const idx = tempUsers.findIndex(user => user.UserId === updatedData.UserId);
      tempUsers[idx] = updatedData;
      return { ...state, users: tempUsers };
    case SET_USER_ROLES:
      return { ...state, roles: action.payload.roles };
    case SET_SYSTEMS_LIST:
      return { ...state, systemsList: action.payload.systems };
    default:
      return state;
  }
};

export default usersData;
